"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function useExternalEventSubscription(id) {
  const {
    item: externalEventSubscription,
    accessor,
    refresh,
    ...rest
  } = useElement(
    WorkspaceElementType.ExternalEventSubscription,
    id,
    (integrationApp) => id ? integrationApp.externalEventSubscription(id) : void 0
  );
  async function setup() {
    await accessor?.setup();
    await refresh();
  }
  async function subscribe() {
    await accessor?.subscribe();
    await refresh();
  }
  async function resubscribe() {
    await accessor?.resubscribe();
    await refresh();
  }
  async function unsubscribe() {
    await accessor?.unsubscribe();
    await refresh();
  }
  async function pullEvents() {
    await accessor?.pullEvents();
    await refresh();
  }
  return {
    externalEventSubscription,
    accessor,
    refresh,
    setup,
    subscribe,
    resubscribe,
    unsubscribe,
    pullEvents,
    ...rest
  };
}

export { useExternalEventSubscription };
